export default __webpack_public_path__ + "static/media/Alina.9352a06e.png";